const numbers = [];

for (let i = 1; i <= 100; i++) {
	numbers.push(i);
}

export default function useNumberOptions() {
	return numbers.map((number) => ({ key: number, text: number, value: number }));
}
